

export class SelectedGpsDevicePortInput implements ISelectedGpsDevicePortInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId!: number;
    /** The auto-generated id of the device model port allocation master */
    deviceModelPortAllocationId!: number;
    /** The reading type should be "Direct" or "Inverse" */
    readingType!: string;
    /** The description with 500 character */
    description!: string;
    /** The work hour calculation should be 1 or 0 */
    workHourCalculation!: number;

    constructor(data?: ISelectedGpsDevicePortInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelPortSpecificationId = _data["deviceModelPortSpecificationId"];
            this.deviceModelPortAllocationId = _data["deviceModelPortAllocationId"];
            this.readingType = _data["readingType"];
            this.description = _data["description"];
            this.workHourCalculation = _data["workHourCalculation"];
        }
    }

    static fromJS(data: any): SelectedGpsDevicePortInput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedGpsDevicePortInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelPortSpecificationId"] = this.deviceModelPortSpecificationId;
        data["deviceModelPortAllocationId"] = this.deviceModelPortAllocationId;
        data["readingType"] = this.readingType;
        data["description"] = this.description;
        data["workHourCalculation"] = this.workHourCalculation;
        return data; 
    }
}

export interface ISelectedGpsDevicePortInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId: number;
    /** The auto-generated id of the device model port allocation master */
    deviceModelPortAllocationId: number;
    /** The reading type should be "Direct" or "Inverse" */
    readingType: string;
    /** The description with 500 character */
    description: string;
    /** The work hour calculation should be 1 or 0 */
    workHourCalculation: number;
}

